module.exports = __webpack_public_path__ + "static/media/ecana_1.2b1f1fc2.jpg";